const ServicesSection = () => {
    return (
        <section>
            <div className="oder_wepper">
                <div className="order_innner_wepper">
                   <div className="order_inneer mb-4">
                        <i className="fa-solid fa-truck-fast mb-2"></i>
                        <div>
                            <p className="mb-0">7 days return & Exchange</p>
                            {/* <span>Orders over Rs. 100</span> */}
                        </div>
                    </div> 
                    <div className="order_inneer mb-4">
                        <i className="fa-regular fa-credit-card mb-2"></i>
                        <div>
                            <p className="mb-0">Quick Payments</p>
                            <span>100% secure payments</span>
                        </div>
                    </div>
                    <div className="order_inneer mb-4">
                        <i className="fa-solid fa-gift mb-2"></i>
                        <div>
                            <p className="mb-0">Ethical & Conscious Brand</p>
                            {/* <span>Buy Rs. 1000 to get card </span> */}
                        </div>
                    </div>
                    <div className="order_inneer mb-4">
                        <i className="fa-solid fa-headset mb-2"></i>
                        <div>
                            <p className="mb-0">24/7 Support</p>
                            <span>Quick support </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ServicesSection;